export const SET_RETENCIONES = "SET_RETENCIONES";
